import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const CFPSOFMI_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/cfpsofmi/logo.png",
        alt: "Child and Family Psychological Services, P.C. Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 52,
  state: "MI",
  departmentIds: [226, 257, 275],
};
